module.exports = __webpack_public_path__ + "static/img/5.893d9c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/set/5/5.jpg
// module id = +R3f
// module chunks = 0